// ═══ '앱으로 보기' 스낵바 — 말소·검차 모드 홈, 휴대폰 웹에서 로그인마다 한 번 (Jin 10/29) ═══
// 웹은 앱 설치 여부를 알 수 없다 → 링크가 알아서 고른다 (Jin 10/29 '앱 바로 열기 넣어줘'):
//   iPhone  = {API 도메인}/app 유니버설 링크 — 새 앱이 깔려 있으면 앱이 열리고, 아니면 서버(routes/appLinks)가 App Store 로.
//            운영 API 도메인(api.autodex.kr) ≠ 웹 도메인(autodex.kr) 이어야 Safari 가 앱을 연다.
//   Android = intent:// (패키지 지정) — 앱 링크 설정이 있는 앱이 깔려 있으면 앱, 아니면 Google Play(설치된 옛 앱은 거기서 '열기').
// 한 번 = 이 로그인 동안: 보이는 순간 sessionStorage 에 표시, App.js login 이 지운다. PC 는 그리지 않는다.
// 자리 = 홈 맨 위 띠(화면 흐름 안). 하단 고정은 끌어 옮길 수 있는 AI도우미 버튼(검차 셸)과 겹친다.
import React, { useEffect, useState } from 'react';
import { T, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { PLAY_STORE } from '../moreActions';
import { API_ORIGIN } from '../../../utils/api';

export var APP_NUDGE_KEY = 'autodex_app_nudge_seen';

function openUrl() {
  var ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  var host = String(API_ORIGIN).replace(/^https?:\/\//, '');
  if (/iPhone|iPad|iPod/i.test(ua)) return API_ORIGIN + '/app';
  if (/Android/i.test(ua)) {
    return 'intent://' + host + '/app#Intent;scheme=https;package=kr.autodex.app;S.browser_fallback_url='
      + encodeURIComponent(PLAY_STORE) + ';end';
  }
  return '';
}

function seen() {
  try { return !!window.sessionStorage.getItem(APP_NUDGE_KEY); } catch (e) { return true; }
}

var bar = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 10px 10px 14px', borderRadius: R.lg,
  background: T.navy, color: T.card };
var text = { flex: 1, minWidth: 0, fontSize: 13, fontWeight: 700, lineHeight: 1.4, wordBreak: 'keep-all' };
var open = { flex: 'none', padding: '8px 12px', borderRadius: R.md, background: T.card, color: T.navy,
  fontSize: 13, fontWeight: 800, textDecoration: 'none', whiteSpace: 'nowrap' };
var close = { flex: 'none', width: 32, height: 32, border: 0, background: 'none', color: T.card, opacity: .75,
  fontSize: 16, cursor: 'pointer', fontFamily: 'inherit' };

// props: { style } — 홈마다 바깥 여백만 다르다.
function AppNudge(props) {
  var t = useT();
  var url = openUrl();
  var st = useState(function () { return !!url && !seen(); });
  var show = st[0], setShow = st[1];

  useEffect(function () {
    if (!show) return;
    try { window.sessionStorage.setItem(APP_NUDGE_KEY, '1'); } catch (e) { /* 저장 불가 — 이번 화면만 */ }
  }, [show]);

  if (!show) return null;
  var hide = function () { setShow(false); };
  return (<div role="status" data-part="app-nudge" style={Object.assign({}, bar, props.style)}>
    <span style={text}>{t('appNudgeText')}</span>
    <a href={url} style={open} onClick={hide}>{t('appNudgeOpen')}</a>
    <button type="button" style={close} aria-label={t('commonClose')} onClick={hide}>✕</button>
  </div>);
}

export default AppNudge;
